module.exports = __webpack_public_path__ + "img/Weapon_127.fe3a2ff9.png";